<template>
  <v-select
    label="Tipo de IVA*"
    v-model="iModel"
    :items="items"
    item-value="Id_TipoIva"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
export default {
  name: "SelectTipoIva",
  props: {
    model: String,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_TipoIva == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  created() {
    this.listarItems();
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get("TipoIva", {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    }
  }
};
</script>
